// extracted by mini-css-extract-plugin
export default {"shipsFromContainer":"_9bec636c","shipsFrom":"_c4147dab"};